import { Box, BoxProps } from '@mui/material';

export const ColorIcon = ({ color, sx }: { color: string; sx?: BoxProps['sx'] }) => (
    <Box
        sx={{
            position: 'relative',
            height: '0.8em',
            width: '0.8em',
            m: '0.1em',
            backgroundColor: color,
            ...sx,
        }}
    />
);

export const BoxLimitIcon = ({
    lineColor,
    fillColor,
    end,
}: {
    lineColor: string;
    fillColor: string;
    end: 'min' | 'max';
}) => (
    <Box
        sx={{
            position: 'relative',
            height: '0.8em',
            width: '0.6em',
            my: '0.1em',
            mx: '0.2em',
            backgroundColor: fillColor,
            borderColor: lineColor,
            boxSizing: 'border-box',
            borderWidth: '1px',
            borderLeftStyle: 'solid',
            borderRightStyle: 'solid',
            [end === 'min' ? 'borderBottomStyle' : 'borderTopStyle']: 'solid',
        }}
    />
);

export const WhiskerLimitIcon = ({ color, end }: { color: string; end: 'min' | 'max' }) => (
    <Box
        sx={{
            position: 'relative',
            height: '0.6em',
            width: '0.8em',
            my: '0.2em',
            mx: '0.1em',
            borderColor: color,
            boxSizing: 'border-box',
            borderWidth: '1px',
            background: `linear-gradient(${color}, ${color}) no-repeat 50% center/1px`,
            [end === 'min' ? 'borderBottomStyle' : 'borderTopStyle']: 'solid',
        }}
    />
);

type LineIconProps =
    | {
          color: string;
          dot?: boolean;
          emptyDot?: undefined;
      }
    | {
          color: string;
          dot?: undefined;
          emptyDot?: boolean;
      };

export const LineIcon = ({ color, dot, emptyDot }: LineIconProps) => (
    <Box
        sx={{
            display: 'flex',
            position: 'relative',
            height: '14px',
            width: '14px',
            m: '1px',
            background: `linear-gradient(${color}, ${color}) no-repeat 50% center / 100% 1px`,
            alignItems: 'center',
            justifyContent: 'center',
        }}
    >
        {dot && (
            <Box
                sx={{
                    position: 'relative',
                    height: '7px',
                    width: '7px',
                    background: color,
                    borderRadius: '50%',
                }}
            ></Box>
        )}
        {emptyDot && (
            <Box
                sx={{
                    position: 'relative',
                    height: '5px',
                    width: '5px',
                    background: 'white',
                    borderColor: color,
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderRadius: '50%',
                }}
            ></Box>
        )}
    </Box>
);

export const SpotIcon = ({ color, sx }: { color: string; sx?: BoxProps['sx'] }) => (
    <ColorIcon
        color={color}
        sx={{
            borderRadius: '50%',
            ...sx,
        }}
    />
);
